<template>
  <div class="forget-1">
    <h1>{{ $t.auth.resetPasswordStep1 }}</h1>
    <card class="card">
      <text-field
        v-model="form.email"
        :icon="require('@/assets/img/auth/icon_login_email.png')"
        :placeholder="$t.auth.placeholderEmail"
      ></text-field>
    </card>
    <div class="btns">
      <div class="btn primary" @click="actionSubmit">
        <span>{{ $t.auth.next }}</span>
      </div>
      <div class="btn" @click="actionLogin">
        <span>{{ $t.auth.backLogin }}</span>
      </div>
    </div>
    <p class="bottom-action" @click="actionRegister">
      <span>{{ $t.auth.noAccountGoRegister }}</span>
    </p>
  </div>
</template>

<script>
import Card from "./components/Card";
import TextField from "./components/TextField";
import Schema from "async-validator";
export default {
  name: "ResetPasswordStep1",
  components: {
    Card,
    TextField
  },
  data() {
    return {
      form: {
        email: ""
      }
    };
  },
  methods: {
    actionSubmit() {
      const rule = {
        email: [
          { required: true, message: this.$t.auth.placeholderEmail },
          { type: "email", message: this.$t.auth.errorEmail }
        ]
      };
      const validator = new Schema(rule);
      validator
        .validate(this.form)
        .then(_ => {
          this.$commonMethod.showLoading();
          return this.$api.login.checkRegisterUser({
            UserName: this.form.email
          });
        })
        .then(res => {
          this.$commonMethod.hideLoading();
          if (res.data) {
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.routerPush,
              {
                isParams: true,
                path: "auth/forget2",
                name: "Forget2",
                query: [
                  {
                    name: "email",
                    value: this.form.email
                  }
                ]
              }
            );
          } else {
            this.$commonMethod.showToast({
              type: "error",
              titleMsg: this.$t.auth.errorEmailNotExist
            });
          }
        })
        .catch(err => {
          if (err.errors) {
            this.$commonMethod.showNotify({
              type: "danger",
              titleMsg: err.errors[0].message
            });
          } else {
            this.$commonMethod.hideLoading();
            this.$commonMethod.showToast({
              type: "error",
              titleMsg: err.message
            });
          }
        });
    },
    actionRegister() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/register",
        name: "Register",
        query: []
      });
    },
    actionLogin() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/login",
        name: "Login",
        query: []
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/var";
.forget-1 {
  padding: 2rem 1rem;
  & > h1 {
    margin: 0;
    padding: 0;
    font-size: 15px;
    color: white;
    font-weight: bold;
  }

  .card {
    margin-top: 15px;
  }

  .btns {
    margin: 43px 25px 60px;

    & > .btn {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $-color-background;
      border-radius: 25px;
      font-size: 15px;
      margin-bottom: 9px;
      border: 0.5px solid $-color-background;

      &.primary {
        background-color: transparent;
        color: white;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .btn-submit {
    height: 50px;
    margin: 35px 25px 0;
    background-color: $-color-background;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 25px;
    font-size: 15px;
  }
  .bottom-action {
    font-size: 14px;
    color: $-color-background;
    text-align: center;
    position: absolute;
    bottom: 25px;
    width: 100%;
    margin: 0 -15px;
  }
}
</style>
